// Ficha de producto de Monderal (ST-10) en Shopify: color, kit, precio y carrito con las
// variantes reales. Los datos salen de <script id="datos-ficha"> (los pone el tema).
// Sin precio tachado ni cuenta atrás: hasta tener un precio anterior real, la ley no los permite.
(() => {
  const datos = JSON.parse(document.getElementById('datos-ficha').textContent);
  const form = document.getElementById('formProducto');
  const $ = id => document.getElementById(id);
  const eur = cents => new Intl.NumberFormat('en-IE', {style: 'currency', currency: datos.moneda}).format(cents / 100);
  const iColor = datos.options.indexOf('Colour'), iKit = datos.options.indexOf('Kit');
  const colorElegido = () => form.querySelector('input[name=color]:checked').value;
  const kitElegido = () => form.querySelector('input[name=pack]:checked').value;
  const variante = (c = colorElegido(), k = kitElegido()) => datos.variants.find(v => v.options[iColor] === c && v.options[iKit] === k);

  /* Galería del color elegido; con el kit «Pump», las fotos de la bomba */
  const lista = () => kitElegido() === 'Pump' ? datos.galeriaBomba : datos.galeria[colorElegido()];
  function verFoto(i) {
    const f = lista()[i];
    $('fotoGrande').src = f.src; $('fotoGrande').alt = f.alt;
    $('miniaturas').querySelectorAll('button').forEach((b, j) => b.setAttribute('aria-current', j === i));
  }
  function pintarGaleria() {
    $('miniaturas').innerHTML = lista()
      .map((f, i) => `<button type="button" aria-label="Photo ${i + 1}"><img src="${f.src}" alt="" loading="lazy"></button>`).join('');
    $('miniaturas').querySelectorAll('button').forEach((b, i) => b.onclick = () => verFoto(i));
    verFoto(Math.max(0, lista().findIndex(f => f.src === datos.kits[colorElegido()][kitElegido()])));
  }

  /* Precio, disponibilidad y fotos de cada kit */
  function pintar() {
    const c = colorElegido(), k = kitElegido(), v = variante();
    $('nombreColor').textContent = c;
    form.querySelectorAll('.pack').forEach(p => {
      const kit = p.querySelector('input').value, vk = variante(c, kit);
      p.querySelector('.foto-pack img').src = datos.kits[c][kit];
      p.querySelector('.importe').textContent = vk ? eur(vk.price) : '';
    });
    // «Pump» a secas es la bomba sola: sin insignia. Con «1 Bag» se avisa de que no lleva bomba.
    $('insigniaBomba').hidden = $('ventajaBomba').hidden = k === 'Pump';
    $('insigniaBomba').textContent = $('textoBomba').textContent = k === '1 Bag' ? 'Pump not included' : 'Pump included';
    if (!v) return;
    $('varianteId').value = v.id;
    $('precioCabecera').textContent = eur(v.price);
    const boton = $('botonCompra');
    boton.disabled = !v.available;
    boton.innerHTML = v.available ? `Add to cart · <span>${eur(v.price)}</span>` : 'Sold out';
    $('barraPack').textContent = k; $('barraPrecio').textContent = eur(v.price);
    $('barraBoton').disabled = !v.available;
    $('barraBoton').textContent = v.available ? 'Add' : 'Sold out';
    history.replaceState(null, '', `?variant=${v.id}`);
  }

  form.querySelectorAll('input[name=color]').forEach(i => i.addEventListener('change', () => { pintarGaleria(); pintar(); }));
  form.querySelectorAll('input[name=pack]').forEach(i => i.addEventListener('change', () => { pintarGaleria(); pintar(); }));
  pintarGaleria(); pintar();

  /* Al carrito, y a la página del carrito */
  const aviso = $('aviso-compra');
  async function añadir() {
    const v = variante();
    if (!v || !v.available) return;
    aviso.hidden = true;
    form.querySelectorAll('button').forEach(b => b.disabled = true);
    try {
      const r = await fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({id: v.id, quantity: 1})});
      if (!r.ok) throw new Error(r.status);
      location.href = '/cart';
    } catch (e) {
      aviso.textContent = 'We could not add it to your cart. Please try again.'; aviso.hidden = false;
      pintar();
    }
  }
  form.addEventListener('submit', e => { e.preventDefault(); añadir(); });
  $('barraBoton').addEventListener('click', añadir);

  /* Barra de compra fija en móvil: sale cuando el botón principal no está a la vista */
  const barra = $('barraCompra');
  new IntersectionObserver(([e]) => { barra.classList.toggle('visible', !e.isIntersecting); barra.setAttribute('aria-hidden', e.isIntersecting); }, {threshold: 0}).observe($('botonCompra'));

  /* Cinta de en medio: cada mitad cubre la pantalla y la velocidad no depende del ancho */
  function rellenarCintas() {
    document.querySelectorAll('.mnd .cinta-pista').forEach(pista => {
      const [a, b] = pista.children;
      const base = a.dataset.base || (a.dataset.base = a.innerHTML);
      a.innerHTML = base;
      while (a.scrollWidth && a.scrollWidth < innerWidth) a.insertAdjacentHTML('beforeend', base);
      b.innerHTML = a.innerHTML;
      pista.style.animationDuration = a.scrollWidth / 40 + 's';
    });
  }
  rellenarCintas();
  let t; addEventListener('resize', () => { clearTimeout(t); t = setTimeout(rellenarCintas, 200); });
})();
